module.exports = __webpack_public_path__ + "static/img/ptfw_abzbwzcg_one.50ccba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ptfw_abzbwzcg_one.png
// module id = 6JWf
// module chunks = 21